import Slider from 'react-slick';
import { styled } from 'styled-components';
import { Row, Col } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ScrollAnimation from 'react-animate-on-scroll';

import Link from './Link';

import img_media_01 from '../assets/mediaArticles/img_media_01.jpg';
import img_media_02 from '../assets/mediaArticles/img_media_02.jpg';
import img_media_03 from '../assets/mediaArticles/img_media_03.jpg';
import img_media_04 from '../assets/mediaArticles/img_media_04.jpg';
import img_media_05 from '../assets/mediaArticles/img_media_05.jpg';
import img_media_06 from '../assets/mediaArticles/img_media_06.jpg';
import img_media_07 from '../assets/mediaArticles/img_media_07.jpg';
import img_media_08 from '../assets/mediaArticles/img_media_08.jpg';
import img_media_09 from '../assets/mediaArticles/img_media_09.jpg';
import img_media_logo_01 from '../assets/mediaArticles/img_media_logo_01.png';
import img_media_logo_02 from '../assets/mediaArticles/img_media_logo_02.png';
import img_media_logo_03 from '../assets/mediaArticles/img_media_logo_03.png';
import img_media_logo_04 from '../assets/mediaArticles/img_media_logo_04.png';
import img_media_logo_05 from '../assets/mediaArticles/img_media_logo_05.png';
import img_media_logo_06 from '../assets/mediaArticles/img_media_logo_06.png';
import img_media_logo_07 from '../assets/mediaArticles/img_media_logo_07.png';
import img_media_logo_08 from '../assets/mediaArticles/img_media_logo_08.jpg';
import img_media_logo_09 from '../assets/mediaArticles/img_media_logo_09.jpg';
import {
    MEDIA_ARTICLE_1,
    MEDIA_ARTICLE_2,
    MEDIA_ARTICLE_3,
    MEDIA_ARTICLE_4,
    MEDIA_ARTICLE_5,
    MEDIA_ARTICLE_6,
    MEDIA_ARTICLE_7,
    MEDIA_ARTICLE_8,
    MEDIA_ARTICLE_9
} from '../data/url';

const MediaArticleWrapper = styled.div`
    padding: 160px 32px;

    @media screen and (max-width: 768px) {
        padding: 100px 20px 80px;
    }
`;

const Header = styled(Row)`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;

    @media screen and (max-width: 768px) {
        font-size: 36px;
        line-height: 48px;
        margin-bottom: 40px;
    }
`;

const CarouselItem = styled.div`
    display: flex !important;
    flex-direction: column;
    align-items: center;

    div {
        width: 80%;
        text-align: left;
        font-size: 18px;
        line-height: 28px;
        margin-top: 10px;
    }
`;

const CustomArrow = styled.div<{ style: React.CSSProperties }>`
    ${({ style }) => ({...style})}
    background-color: #45B9AE;
    width: 40px; 
    height: 40px;
    border-radius: 30px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    display: flex !important;
    justify-content: center;
    align-items: center;
    z-index: 20;
    
    &:before {
        display: none; 
    }

    &:hover {
        color: #FFFFFF;
        background: #45B9AE;
    }
`;

const MediaArticle = () => {

    const PrevArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, left: '-15px' }} >
            <LeftOutlined/>
        </CustomArrow>
    );

    const NextArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, right: '-15px' }} >
            <RightOutlined/>
        </CustomArrow>
    );

    return (
        <MediaArticleWrapper>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <Header>媒體報導</Header>
                <Row>
                    <Col md={24} sm={0} xs={0}>
                    <Slider
                        slidesToShow={2}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_1} style={{ width: '80%' }}>
                                <img src={img_media_01} alt='img_media_01' style={{ width: '100%' }} />
                            </Link>
                            <div>落實企業ESG的好幫手！Workute AI運動APP，員工健康促進的絕佳方案</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_01} alt='img_media_logo_01' style={{ width: '40px', marginRight: '10px' }} />
                                銳傳媒
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_2} style={{ width: '80%' }}>
                                <img src={img_media_02} alt='img_media_02' style={{ width: '100%' }} />
                            </Link>
                            <div>健身版網友瘋狂討論，史上最萌居家健身神器 ”Workute”！AI教練即時輔助，不用再怕姿勢不正確！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_02} alt='img_media_logo_02' style={{ width: '40px', marginRight: '10px' }} />
                                POPDAILY
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_3} style={{ width: '80%' }}>
                                <img src={img_media_03} alt='img_media_03' style={{ width: '100%' }} />
                            </Link>
                            <div>手機 1 秒變身成教練 Workute 你的居家運動超萌夥伴！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_03} alt='img_media_logo_03' style={{ width: '40px', marginRight: '10px' }} />
                                運動筆記
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_4} style={{ width: '80%' }}>
                                <img src={img_media_04} alt='img_media_04' style={{ width: '100%' }} />
                            </Link>
                            <div>最萌AI運動APP，居家運動神器</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_04} alt='img_media_logo_04' style={{ width: '40px', marginRight: '10px' }} />
                                銳傳媒
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_5} style={{ width: '80%' }}>
                                <img src={img_media_05} alt='img_media_05' style={{ width: '100%' }} />
                            </Link>
                            <div>運動妞小幫手～Workute讓妳宅家也能練出完美曲線！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_05} alt='img_media_logo_05' style={{ width: '40px', marginRight: '10px' }} />
                                妞新聞
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_6} style={{ width: '80%' }}>
                                <img src={img_media_06} alt='img_media_06' style={{ width: '100%' }} />
                            </Link>
                            <div>體驗最新 XR 與運動科技！「Empower Block 賦能台北基地」對外開放 引領親子在虛實世界健身</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_06} alt='img_media_logo_06' style={{ width: '40px', marginRight: '10px' }} />
                                上報
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_7} style={{ width: '80%' }}>
                                <img src={img_media_07} alt='img_media_07' style={{ width: '100%' }} />
                            </Link>
                            <div>Baby Sports「寶貝運動會」國慶連假登場　七大項目任你玩</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_07} alt='img_media_logo_07' style={{ width: '40px', marginRight: '10px' }} />
                                今日新聞
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_8} style={{ width: '80%' }}>
                                <img src={img_media_08} alt='img_media_08' style={{ width: '100%' }} />
                            </Link>
                            <div>【Workout 健身小精靈】推薦文</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_08} alt='img_media_logo_08' style={{ width: '40px', marginRight: '10px' }} />
                                吉雷米-一粒米
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_9} style={{ width: '80%' }}>
                                <img src={img_media_09} alt='img_media_09' style={{ width: '100%' }} />
                            </Link>
                            <div>【Workout 企業方案】推薦文</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_09} alt='img_media_logo_09' style={{ width: '40px', marginRight: '10px' }} />
                                芒果姐姐的職場護理思
                            </div>
                        </CarouselItem>
                    </Slider>
                    </Col>
                    <Col md={0} sm={24} xs={24}>
                    <Slider
                        slidesToShow={1}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_1} style={{ width: '80%' }}>
                                <img src={img_media_01} alt='img_media_01' style={{ width: '100%' }} />
                            </Link>
                            <div>落實企業ESG的好幫手！Workute AI運動APP，員工健康促進的絕佳方案</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_01} alt='img_media_logo_01' style={{ width: '40px', marginRight: '10px' }} />
                                銳傳媒
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_2} style={{ width: '80%' }}>
                                <img src={img_media_02} alt='img_media_02' style={{ width: '100%' }} />
                            </Link>
                            <div>健身版網友瘋狂討論，史上最萌居家健身神器 ”Workute”！AI教練即時輔助，不用再怕姿勢不正確！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_02} alt='img_media_logo_02' style={{ width: '40px', marginRight: '10px' }} />
                                POPDAILY
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_3} style={{ width: '80%' }}>
                                <img src={img_media_03} alt='img_media_03' style={{ width: '100%' }} />
                            </Link>
                            <div>手機 1 秒變身成教練 Workute 你的居家運動超萌夥伴！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_03} alt='img_media_logo_03' style={{ width: '40px', marginRight: '10px' }} />
                                運動筆記
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_4} style={{ width: '80%' }}>
                                <img src={img_media_04} alt='img_media_04' style={{ width: '100%' }} />
                            </Link>
                            <div>最萌AI運動APP，居家運動神器</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_04} alt='img_media_logo_04' style={{ width: '40px', marginRight: '10px' }} />
                                銳傳媒
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_5} style={{ width: '80%' }}>
                                <img src={img_media_05} alt='img_media_05' style={{ width: '100%' }} />
                            </Link>
                            <div>運動妞小幫手～Workute讓妳宅家也能練出完美曲線！</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_05} alt='img_media_logo_05' style={{ width: '40px', marginRight: '10px' }} />
                                妞新聞
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_6} style={{ width: '80%' }}>
                                <img src={img_media_06} alt='img_media_06' style={{ width: '100%' }} />
                            </Link>
                            <div>體驗最新 XR 與運動科技！「Empower Block 賦能台北基地」對外開放 引領親子在虛實世界健身</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_06} alt='img_media_logo_06' style={{ width: '40px', marginRight: '10px' }} />
                                上報
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_7} style={{ width: '80%' }}>
                                <img src={img_media_07} alt='img_media_07' style={{ width: '100%' }} />
                            </Link>
                            <div>Baby Sports「寶貝運動會」國慶連假登場　七大項目任你玩</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_07} alt='img_media_logo_07' style={{ width: '40px', marginRight: '10px' }} />
                                今日新聞
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_8} style={{ width: '80%' }}>
                                <img src={img_media_08} alt='img_media_08' style={{ width: '100%' }} />
                            </Link>
                            <div>【Workout 健身小精靈】推薦文</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_08} alt='img_media_logo_08' style={{ width: '40px', marginRight: '10px' }} />
                                吉雷米-一粒米
                            </div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={MEDIA_ARTICLE_9} style={{ width: '80%' }}>
                                <img src={img_media_09} alt='img_media_09' style={{ width: '100%' }} />
                            </Link>
                            <div>【Workout 企業方案】推薦文</div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={img_media_logo_09} alt='img_media_logo_09' style={{ width: '40px', marginRight: '10px' }} />
                                芒果姐姐的職場護理思
                            </div>
                        </CarouselItem>
                    </Slider>
                    </Col>
                </Row>
            </ScrollAnimation>
        </MediaArticleWrapper>
    );
};

export default MediaArticle;